// src/pages/Company/Company.js
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './Company.scss'
// Remove unused icons: faChartColumn, faRecycle, faCodepen
import { useRefs } from '../../context/RefContext'
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { Trans } from "@lingui/react/macro"; // Import `t` as well for variables
import {t} from "@lingui/core/macro"
import { Link, useNavigate } from 'react-router-dom';
import companyLogo from '../../images/trimmed_logo.png'; // Placeholder for your actual logo image

const Company = () =>
{
    useEffect(() =>
    {
        Aos.init({ duration: 1000, once: true, easing: 'ease-in-out' });
    }, []); // Empty dependency array means this runs once on mount

    const { companyRef } = useRefs();

    // Your new content for the Company section
    //const companyp1 = t`Inspirados por esta metáfora del admirable Carl Sagan, y guiados por la experiencia de un gran equipo, trabajamos para diseñar, con ingeniería, los sueños de aventurarnos al Cosmos.`;
    //const companyp2 = t`En una era con cada vez más viajes al espacio, creemos que el futuro de la Humanidad se extiende más allá de la Tierra. Por esto, nos dedicamos a construir puertos espaciales con la infraestructura necesaria para hacerlos realidad. El desafío es transformar la compleja logística espacial actual en una experiencia fluida y eficiente, cotidiana y segura.`;

    return (
        <div className='company-section'> {/* Renamed class to 'company-section' */}
            <div ref={companyRef}  className='company-container'> {/* Renamed class to 'company-container' */}

                <div  className='company-logo' data-aos="fade-in"> {/* New div for logo */}
                    <img src={companyLogo} alt="Company Logo" />
                </div>

                <div className='company-text' data-aos="fade-in"> {/* New div for heading and paragraph */}
                    <p className='open_sans'>
                        <Trans>
                            Inspirados en la metáfora del reconocido Carl Sagan, y guiados por la experiencia de un equipo multidisciplinario, trabajamos para transformar en proyectos concretos la visión de expandir la actividad humana hacia el espacio.
                        </Trans>
                    </p>
                    <br/>
                    <p className='open_sans'>
                        <Trans>
                          Cosmic Shores es una empresa orientada al desarrollo de infraestructura espacial y territorial asociada, especializada en la planificación estratégica, el diseño conceptual y la evaluación integral de plataformas de acceso al espacio.  
                        </Trans>
                    </p>
                    <br/>
                    <p className='open_sans'>
                        <Trans>
                        En una era caracterizada por el crecimiento sostenido de las actividades espaciales, entendemos que el futuro de la humanidad se proyecta más allá de la Tierra. En este contexto, trabajamos en el desarrollo de espaciopuertos y ecosistemas asociados, integrando criterios técnicos, regulatorios, ambientales y territoriales.
                        </Trans>
                    </p>
                    <br/>
                    <p className='open_sans'>
                        <Trans>
                            Nuestro desafío es contribuir a transformar la compleja logística espacial en sistemas operativos eficientes, seguros y sostenibles, facilitando el acceso al espacio como una actividad progresivamente más integrada a la vida cotidiana
                        </Trans>
                    </p>
                </div>
                
            </div>
            {/*<div className='developments-section' data-aos="fade-in"> <Link
                            to="/desarrollos" className="developments-links" ><div className='block'><Trans>CONOZCA</Trans></div>
                <div className='block outline'><Trans>NUESTROS DESARROLLOS</Trans></div></Link></div> */}
        </div> 
    );
};

export default Company;